import { defineMessages } from "react-intl";

export const scope = "components.TaxWarning";

export const messages = defineMessages({
  debitWarning: {
    id: `${scope}.debitWarning`,
    defaultMessage:
      "Recordá que el débito de {tickerId} en tu cuenta puede estar sujeto a una retención del {amount}%.",
  },
  creditWarning: {
    id: `${scope}.creditWarning`,
    defaultMessage:
      "Recordá que el crédito de {tickerId} en tu cuenta puede estar sujeto a una retención del {amount}%.",
  },
});
